import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import LiftSign from "../assets/Measurements/Images/LiftSign.png"
import LineTo from 'react-lineto';

var image;

function fitImage(src) {
  var image = new Image();
  image.src = src;
  var height = image.height;
  var width = image.width;
  var scale;

  var color = "0";

  if (width > height) { // Image is wider than it's high
    scale = 90 / height;
  }
  else { // Image is higher than it's wide
    scale = 90 / width;
  }

  image.width = width * scale;
  image.height = height * scale;

  document.getElementById('info').innerHTML = width + 'x' + height + ' => ' + image.width + 'x' + image.height;

  document.getElementById('container').style.backgroundImage = 'url(' + image.src + ')';
  document.getElementById('container').style.backgroundSize = image.width + 'px ' + image.height + 'px';
}

var hideImageStart = false;
var oldQuestion = undefined;

export default function MultipleChoice({ currentQuestion, ...props }) {


  var hideImage = false;
  var timeout;

  var DelayImage = function (delay) {
  if(timeout != undefined){
      clearTimeout(timeout);
  }
    console.log("Hide image start:" + hideImageStart);
    console.log("Hide image:" + hideImage);
    if (hideImageStart == false) {
      hideImageStart = true;
      hideImage = false;
      console.log("Displaying image for " + delay);
      timeout = setTimeout(HideImage, delay * 1000); 
    }
  }
  
  function HideImage() {
    hideImageStart = false;
    hideImage = true;
    image = require('../assets/NumberSense/Images/Empty.png');
  }

  //filter button list
  let buttonList = [];
  if (currentQuestion.answers != undefined) {
    for (let i = 0; i < currentQuestion.answers.length; i++) {
      if (currentQuestion.answers[i].name)
        console.log("push")
    }
  }

  if (oldQuestion != currentQuestion && (currentQuestion.image != "" && currentQuestion.image != undefined)) {
    console.log(oldQuestion);
    console.log(currentQuestion);
    oldQuestion = currentQuestion;
    var currImage = currentQuestion.image;
    var correctAnswerName;
    //gets correct answer name for testing
    for (let i = 0; i < currentQuestion.answers.length; i++) {
      if (currentQuestion.answers[i].correct == true)
        correctAnswerName = currentQuestion.answers[i].value;
    }
    image = require('../assets/NumberSense/Images/' + currImage);
    //console.log(oldQuestion);
    //console.log(currentQuestion);
    //console.log(currentQuestion.time);
    if (hideImageStart == false && currentQuestion.time != "") {
      //start timer thing if timer is a thing
      console.log("do delay thing");
      DelayImage(parseInt(currentQuestion.time));
      
    }
  }

  function FilteredAnswers() {
    return currentQuestion.answers.filter(v => v.value !== "");
  }

  function Template({ html }) {
    return (
      <div dangerouslySetInnerHTML={{ __html: html }} />
    );
  }

  return (
    <>
      <Container>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Question
            type="text"
            disabled
            value={
              currentQuestion.question !== undefined
                ? currentQuestion.question.replace("$", "?")
                : ""
            }
          ><Textfit mode="single" style={{ height: "100%" }} > {currentQuestion.question}</Textfit></Question>
        </div>
        {currentQuestion.question2 !== undefined && currentQuestion.question2 !=="" ?
          <Question
            type="text"
            disabled
            value={
              currentQuestion.question2 !== undefined
                ? currentQuestion.question2.replace("$", "?")
                : ""
            }
            ><Textfit mode="multi" max="40" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question2) }} />}</span></Textfit></Question>
          : ""}

        <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
          {currentQuestion.image != "" && currentQuestion.questionHTML == "" ? (
            <img src={image}></img>
            /*<img src = {image} className ={style.geoImg} filter = {hue-rotate(60deg);}></img>*/
          ) : (
              <div></div>
            )}
          {currentQuestion.questionHTML != "" ? (
            //<div dangerouslySetInnerHTML={{__html: currentQuestion.questionHTML}}></div>
            //<div><img src={require("../assets/Measurements/Images/LiftSign.png")}></img></div>
            //<div innerHtml={currentQuestion.questionHTML}></div>
            <DynamicStyle>
              <div dangerouslySetInnerHTML={{ __html: currentQuestion.questionHTML }}></div>
            </DynamicStyle>
          ) :
            (
              <div></div>
            )}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          {props.onShowFeedback == false && currentQuestion.answers !== undefined &&
            FilteredAnswers().map(answer => (

              <Button
                value={answer.value}
                onClick={() => props.onSubmit(answer, currentQuestion)}
              >
                <div style={{ height: "80%", width: "100%" }}>
                  <Textfit mode="multi" max="99" style={{ height: "100%" }}>
                    {answer.value}
                  </Textfit>
                </div>
              </Button>
            ))}

          {props.onShowFeedback == true && currentQuestion.answers !== undefined &&
            FilteredAnswers().map(answer => (

              <Button
                value={answer.value}
                style={{...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
              >
                <div style={{ height: "80%", width: "100%" }}>
                  <Textfit mode="multi" max="99" style={{ height: "100%" }}>
                    {answer.value}
                  </Textfit>
                </div>
              </Button>
            ))}
        </div>
      </Container>
    </>
  );
}

const ButtonText = styled.div`
margin: 0 auto;
font-size: 2vw;
padding: 0;
vertical-align: middle;
text-align: center;
display: table-cell;
`

const ButtonImage = styled.img`
height:105%;
//max-width: 80%;
//max-height: 80%;
//padding-top: 15px;
`

//this is green atm
const ColouredImage = styled.img`
  filter: sepia() saturate(10000%) hue-rotate(60deg);
`;

const ScaledImage = styled.img`
  zoom: 2;
  -webkit-transform: scale(2);
  -moz-transform: scale(2);
  -ms-transform: scale(2);
  -o-transform: scale(2);
  transform: scale(2);
`;

const Container = styled.div`
width:80%
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom:100px;
`;

const Question = styled.div`
  background: #FFF;
  user-select: none;
  width: 90%;
  height: 120px;
  line-height: 90px;
  font-size: 4em;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
`;

const Button = styled.div`
  text-align: center;
  width: 20%;
  height: 150px;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;

/*
const Button = styled.div`
  text-align: center;
  width: 10%;
  height: 150px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
*/